<template>
  <div class="bg-[#1A528E] py-3 text-white w-full">
    <nav class="mx-auto items-center flex px-6 min-[1024px]:px-12 min-[1440px]:px-0 max-w-[1140px] justify-between">
      <TreatmentDropdown :content="props.content.primaryExpandedContent" />
      <ul class="flex">
        <li
          v-for="({ label, href }, index) in props.content.secondaryNavigationLinks"
          :key="label"
          class="flex"
          :class="{ '!hidden min-[1024px]:!flex': index > 3 }"
        >
          <a
            :href="href"
            class="px-4 min-[1440px]:px-6 py-2 hover:bg-[#003F82] focus:bg-[#003F82] rounded-full"
            :class="{ 'underline underline-offset-8': path === href }"
          >
            {{ label }}
          </a>
        </li>
        <li class="flex">
          <a
            href="/account-dashboard"
            class="flex items-center justify-center px-4 min-[1440px]:px-6 py-2 hover:bg-[#003F82] focus:bg-[#003F82] rounded-full"
          >
            <AccountCircle class="w-5 h-5 flex-shrink-0 mr-[10px]" />
            Account
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script setup lang="ts">
import TreatmentDropdown from "./TreatmentDropdown.vue";
import { DRXNavigationContent } from "../types";
import AccountCircle from "../../../resources/account-circle.svg?inline";

const props = defineProps<{
  content: DRXNavigationContent;
}>();

const path = window.location.pathname;
</script>

<style scoped>
@tailwind base;
@tailwind components;
@tailwind utilities;
</style>

<style lang="scss" scoped>
@import "@theme/Main.scss";
</style>
